/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Out_Reason_For_SaleInputs */

const vi_pkl_out_reason_for_sale = /** @type {(inputs: Pkl_Out_Reason_For_SaleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất theo đơn hàng`)
};

/**

* @param {Pkl_Out_Reason_For_SaleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_out_reason_for_sale = /** @type {((inputs?: Pkl_Out_Reason_For_SaleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Out_Reason_For_SaleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_out_reason_for_sale(inputs)
});